export const RegistrationRoutes = publicConfiguration.isOAuthEnabled() ? [
    {
        "url": "/user",
        "name": "registration",
        "type": "frontend",
        "loginRequired": false,
        "abstract": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/registration/registration.downgrade.module");
                }
            }
        ],
    },
    // {
    //     "url": "/signup2",
    //     "name": "registration.signup",
    //     "type": "frontend",
    //     "loginRequired": false,
    //     "component": "registrationSignupContainer",
    //     "route_styles": {
    //         framework: "bootstrap_v4",
    //         styles: ["registration"]
    //     },
    // },
    {
        "url": "/signup",
        "name": "registration.usertype",
        "type": "frontend",
        "loginRequired": false,
        "component": "registrationUsertypeContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
    },
    {
        "url": "/employer?source&packageId&isSubscription&redirectToState&redirectToUrl",
        "name": "registration.employer",
        "type": "frontend",
        "loginRequired": false,
        "component": "registrationEmployerContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
    },
    {
        "url": "/candidate",
        "name": "registration.candidate",
        "type": "frontend",
        "loginRequired": false,
        "component": "registrationCandidateContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
    },
    {
        "url": "/login?ref&IR", // IR: IsRadisson
        "name": "registration.login",
        "type": "frontend",
        "loginRequired": false,
        "component": "registrationLoginContainer",
        "params": {
            code: ''
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration", "two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            }
        ],
    },
    {
        "url": "/refresh?code",
        "name": "registration.refresh",
        "type": "frontend",
        "loginRequired": false,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
        "onEnter": ['$state', 'hUser', async function ($state, hUser) {
                hUser.logout();
                Utils.redirectToWorkspace('homepage');
            }],
    },
    {
        "url": "/logout",
        "name": "registration.logout",
        "type": "frontend",
        "loginRequired": false,
        "onEnter": ['$state', async function ($state) {
                window.localStorage.clear();
                Utils.redirectToWorkspace('registration.login');
            }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
    },
    {
        "url": "/refresh-logout",
        "name": "registration.refresh-logout",
        "type": "frontend",
        "loginRequired": false,
        "onEnter": ['$state', function ($state) {
                Utils.redirectToWorkspace('registration.login', {});
            }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
    },
    {
        "url": '/brand%slug',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/registration/registration.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/apply/:job_id",
        "name": "job-post.apply",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/registration/registration.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/careers/brand%slug?talent_scout_code_id",
        "name": "career-portal-story",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/registration/registration.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/setup-mfa",
        "name": "registration.setupMfa",
        "type": "frontend",
        "loginRequired": true,
        "component": "mfaSetupContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["registration", "two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            }
        ],
    },
] : [];
//# sourceMappingURL=registration.routes.js.map